import type { HeatmapPoint } from '@/types/dashboard'
import type { WidgetProps } from './WidgetProps'
import { ActivityWidgetContent } from './ActivityWidgetContent'

/**
 * Сводная активность учителя: он сам и его ученики. При высоте 2+ рядов
 * под графиком появляется таймлайн с именами авторов событий.
 */
export function ActivityHeatmapWidget({ payload, rows }: WidgetProps) {
  const days = (payload.days ?? []) as HeatmapPoint[]
  const from = typeof payload.from === 'string' ? payload.from : ''
  const to = typeof payload.to === 'string' ? payload.to : ''

  return (
    <ActivityWidgetContent
      from={from}
      to={to}
      days={days}
      rows={rows}
      scope="students"
      showUserName
    />
  )
}
